import { render, staticRenderFns } from "./students-alerts.vue?vue&type=template&id=ebc881ac&"
import script from "./students-alerts.vue?vue&type=script&lang=js&"
export * from "./students-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports